import { FunctionComponent, useState } from 'react';
import { Button, IconButton, Tabs, Dialog, Select, Table, TableRow, TableCell } from '../../tailwindcomponents';
import { DatePicker } from '../../MaterialUiComponents';
import { Typography, Input } from '../../tailwindcomponents';
import { AddCircle, Edit } from '../../components/icons';
import EditColumn from '../Security/EditColumn';
import liteApi from '../../api/lite';
import { EmployeeSearch, Collection } from '../../components';
import { HandoverMetaCard } from '../../components/Handover';
import { LiteHandoverReportInformation, LiteHandoverIssues } from '../../types/lite';
import { User } from '../../types/user';
import LineHandoverMxiPackageInformation from './LiteHandoverMxiPackageInformation';

interface LiteHandoverDialogContextProps {
    allTails: Array<string>,
    liteHandoverReport: LiteHandoverReportInformation,
    refresh: Function,
    onClose: Function,
    refreshLiteHandOverTab: Function,
    workPlace: string,
    isEditMode: Boolean,
}

const LiteHandoverDialogContext: FunctionComponent<LiteHandoverDialogContextProps> = ({ allTails, liteHandoverReport, refresh, onClose, refreshLiteHandOverTab, workPlace, isEditMode }) => {
    const [editIndex, setEditIndex] = useState(-1);
    const [selectedTailNumber, setSelectedTailNumber] = useState("");
    const [selectedIssue, setSelectedIssue] = useState("");
    const [areYouSureDialogOpen, setAreYouSureDialogOpen] = useState<boolean>(false);
    const [openDatePicker, setOpenDatePicker] = useState<boolean>(false);
    const [beginDate, setBeginDate] = useState<Date>(new Date());
    const [endDate, setEndDate] = useState<Date>(new Date());
    const [tabValue, setTabValue] = useState<number>(0);

    const generateTableBody = (row: LiteHandoverIssues, index: number) => {
        return (
            editIndex === index ?
                <TableRow >
                    <TableCell>{index}</TableCell>
                    <TableCell>{row.created_date_text}</TableCell>
                    <TableCell>
                        <Select width={100} widthPercentage filter_by_text="Tail number" onSelectedItem={(e: any) => setSelectedTailNumber(e.target.value)} options={allTails} selectedItem={selectedTailNumber} />
                    </TableCell>
                    <TableCell>   <Input multiline={true} help_text={""} label_text={"Issue"} value={selectedIssue} onTextChange={(text: string) => setSelectedIssue(text)} type="text" width={100} /></TableCell>
                    <EditColumn
                        index={index}
                        saveChanges={() => onModifieIssue(row.id)}
                        deleteRow={() => onDeleteIssue(row.id)}
                        editRow={index}
                        setEditRow={(editRow: number) => { }} />
                </TableRow>
                :
                <TableRow >
                    <TableCell>{index}</TableCell>
                    <TableCell>{row.created_date_text}</TableCell>
                    <TableCell>{row.tail_number}</TableCell>
                    <TableCell>{row.issue}</TableCell>
                    {liteHandoverReport.is_submitted === false ? isEditMode && <TableCell><IconButton onClick={() => onSelectRow(row, index)}><Edit /></IconButton> </TableCell> : <TableCell></TableCell>}
                </TableRow>
        )
    }
    const onSelectRow = (row: LiteHandoverIssues, index: number) => {
        setEditIndex(index);
        setSelectedIssue(row.issue);
        setSelectedTailNumber(row.tail_number);
    }
    const onAddIssue = () => {
        if (isEditMode) {
            liteApi.AddIssue(liteHandoverReport.id, "", "").then(res => {
                setEditIndex(liteHandoverReport.issues_count + 1);
                setSelectedTailNumber("");
                setSelectedIssue("");
                refresh(liteHandoverReport.id);
            });
        }
    }
    const onDeleteIssue = (issueId: number) => {
        if (isEditMode) {
            liteApi.DeleteIssue(issueId).then(res => {
                refresh(liteHandoverReport.id);
                setSelectedTailNumber("");
                setSelectedIssue("");
                setEditIndex(-1);
            });
        }
    }
    const onModifieIssue = (issueId: number) => {
        if (isEditMode) {
            liteApi.UpdateIssue(issueId, selectedIssue, selectedTailNumber).then(res => {
                refresh(liteHandoverReport.id);
                setSelectedTailNumber("");
                setEditIndex(-1);
            });
        }
    }
    const onAddEmployeeLabour = (user: User | null) => {
        if (!user) return;
        if (isEditMode) {
            liteApi.AddLabour(liteHandoverReport.id, user.user_id).then(res => {
                refresh(liteHandoverReport.id);
            });
        }
    }
    const onDeleteEmployeeLabour = (labourID: number) => {
        if (isEditMode) {
            liteApi.DeleteLabour(liteHandoverReport.id, labourID).then(res => {
                refresh(liteHandoverReport.id);
            });
        }
    }
    const onAddEmployeeLabourMC = (user: User | null) => {
        if (!user) return;
        if (isEditMode) {
            liteApi.AddLabourMC(liteHandoverReport.id, user.user_id).then(res => {
                refresh(liteHandoverReport.id);
            });
        }
    }
    const onDeleteEmployeeLabourMC = (labourID: number) => {
        if (isEditMode) {
            liteApi.DeleteLabourMC(liteHandoverReport.id, labourID).then(res => {
                refresh(liteHandoverReport.id);
            });
        }
    }
    const onAreYouDialogClicked = (status: boolean) => {
        if (isEditMode) {
            if (status === true) {
                liteApi.CloseLiteHandoverReport(workPlace).then(res => {
                    setAreYouSureDialogOpen(false);
                    onClose();
                    refreshLiteHandOverTab();
                });
            } else {
                setAreYouSureDialogOpen(false);
                onClose();
            }
        }
    }
    const onSubmitBeginEndDate = () => {
        if (isEditMode) {
            liteApi.UpdateLiteHandOverReportDates(liteHandoverReport.id, beginDate, endDate).then(res => {
                refresh(liteHandoverReport.id);
            });
            setOpenDatePicker(false);
        }
    }
    return (
        <div>
            <div>
                {liteHandoverReport.is_submitted === false && isEditMode && <div className="flex flex-wrap justify-center gap-2">
                    <Button variant="text" onClick={() => setAreYouSureDialogOpen(true)} color='primary'>Finish report</Button>
                    <Button variant="text" onClick={() => setOpenDatePicker(!openDatePicker)} color='primary'>Select start end date</Button>
                </div>}
                <div className="flex flex-wrap justify-center">
                    {openDatePicker === true &&
                        <div className="flex flex-wrap justify-center">
                            <div>
                                <DatePicker type="DateAndTime" selected={beginDate} label="Begin time" onDateChange={(date: Date) => { setBeginDate(date) }} />
                            </div>
                            <div>
                                <DatePicker type="DateAndTime" selected={endDate} label="End time" onDateChange={(date: Date) => { setEndDate(date) }} />
                            </div>
                            <div>
                                <Button variant="text" onClick={() => onSubmitBeginEndDate()} color='primary'>Submit dates</Button>
                            </div>
                        </div>
                    }
                </div>
                <HandoverMetaCard
                    createdBy={liteHandoverReport.supervisor_name}
                    createdDate={liteHandoverReport.created_date_text}
                    startDate={liteHandoverReport.begin_date_text}
                    endDate={liteHandoverReport.end_date_text}
                    shift={liteHandoverReport.shift}
                    isDayShift={liteHandoverReport.day ?? null}
                />
                <Typography text={'Issues'} align={'center'} variant='h2' />
                <Table
                    headers={["Created date", "Aircraft", "Issue", ""]}
                    rows={liteHandoverReport.handover_issues ?? []}
                    generateBody={(row: LiteHandoverIssues, index: number) => generateTableBody(row, index)}
                    defaultRowsPerPage={25}
                    pagination={false}
                    skipIndexCol={false}
                />
                {liteHandoverReport.is_submitted === false && isEditMode &&
                    <div className="flex flex-col items-center">
                        <IconButton onClick={() => onAddIssue()} className="text-success" >
                            <AddCircle />
                        </IconButton>
                    </div>
                }
            </div>
            <div className="flex gap-3">
                <div className="flex-1 min-w-0">
                    {liteHandoverReport.is_submitted === false && isEditMode &&
                        <EmployeeSearch place_holder={workPlace === "LITE" ? "Lite employees" : "RVK Line Employees"} clearOnSelect fullUser={true} onSelectedEmployee={(employee: User | null) => onAddEmployeeLabour(employee)} inputWidth={95} />
                    }
                    <Collection
                        edit={liteHandoverReport.is_submitted === false}
                        background={false}
                        collectionList={liteHandoverReport.handover_employees ?? []}
                        title={workPlace === "LITE" ? "Lite employees" : "RVK Line Employees"}
                        nameProperty="name"
                        removeItem={(itemId: number) => onDeleteEmployeeLabour(itemId)}
                    />
                </div>
                {workPlace === "LITE" &&
                    <div className="flex-1 min-w-0">
                        {liteHandoverReport.is_submitted === false && isEditMode &&
                            <EmployeeSearch place_holder={"Mc employees"} clearOnSelect fullUser={true} onSelectedEmployee={(employee: User | null) => onAddEmployeeLabourMC(employee)} inputWidth={95} />
                        }
                        <Collection
                            edit={liteHandoverReport.is_submitted === false}
                            background={false}
                            collectionList={liteHandoverReport.handover_mc_employees ?? []}
                            title="MC employees"
                            nameProperty="name"
                            removeItem={(itemId: number) => onDeleteEmployeeLabourMC(itemId)}
                        />
                    </div>
                }
            </div>
            {
                workPlace === "LITE" &&
                <div className="flex flex-wrap justify-center">
                    <Tabs
                        tabNames={["Hidden", "Lite Package", "Turn Checks"]}
                        onChangeTabValue={(tabValue: number) => setTabValue(tabValue)}
                        tabValue={tabValue}
                    />
                </div>
            }
            <LineHandoverMxiPackageInformation tabValue={tabValue} reportId={liteHandoverReport.id} />
            <Dialog
                visible={areYouSureDialogOpen}
                max_width={"md"} title={"Are you sure you want to finish this report"}
                context={
                    <div></div>
                }
                onClose={(status: any) => onAreYouDialogClicked(status)}
                strict={false}
                show_options={true}
            />
        </div>
    );
};
export default LiteHandoverDialogContext;